import { formatValue, colorByValue, statusToColor } from './formatValue';

function StatItem({ label, value, format, prefix, suffix, change, trend, status, description }) {
    const displayValue = format ? formatValue(value, format) : String(value ?? '—');
    const changeColor = status ? statusToColor(status) : colorByValue(change);
    const valueColor = status ? statusToColor(status)
        : (format === 'percent' ? colorByValue(value) : 'text-gray-900 dark:text-gray-100');

    return (
        <div className="min-w-0">
            {label && (
                <div className="text-xs text-gray-500 dark:text-gray-400 mb-1 truncate">{label}</div>
            )}
            <div className="flex items-baseline gap-1 flex-wrap">
                {prefix && <span className="text-sm text-gray-500 dark:text-gray-400">{prefix}</span>}
                <span className={`text-xl font-medium truncate ${valueColor}`}>
                    {displayValue}
                </span>
                {suffix && <span className="text-sm text-gray-500 dark:text-gray-400">{suffix}</span>}
                {change != null && (
                    <span className={`text-sm font-medium ${changeColor}`}>
                        {formatValue(change, 'percent')}
                    </span>
                )}
            </div>
            {description && (
                <div className="text-xs text-gray-400 dark:text-gray-500 mt-0.5 truncate">{description}</div>
            )}
        </div>
    );
}

export default function NativeStat({ items, columns, title, subtitle }) {
    const cols = columns || Math.min(items?.length || 1, 4);
    const gridClass = `grid gap-4 grid-cols-${cols}`;

    return (
        <div>
            {title && <div className="text-sm font-medium text-gray-900 dark:text-gray-100 mb-3">{title}</div>}
            {subtitle && <div className="text-xs text-gray-500 dark:text-gray-400 mb-3">{subtitle}</div>}
            <div className={gridClass} style={{ gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))` }}>
                {(items || []).map((item, i) => (
                    <div
                        key={i}
                        className="bg-gray-50 dark:bg-white/5 rounded-lg p-3"
                    >
                        <StatItem {...item} />
                    </div>
                ))}
            </div>
        </div>
    );
}

export { StatItem };
